import {BlockSelector, ESD_BLOCK_TEXT} from '../../constants/BlockName';
import {ImmutableHtmlNode} from '../../modifications/ImmutableNode';
import {BuiltInControl} from '../BuiltInControl';

export abstract class TextBuiltInControl extends BuiltInControl {
  public getTargetNodes(root: ImmutableHtmlNode): ImmutableHtmlNode[] {
    const texts = root.querySelectorAll(BlockSelector.TEXT);
    const text = root.asElement().hasClass(ESD_BLOCK_TEXT) ? [root] : [];
    return texts.length ? texts : text;
  }
}
